export const ERROR_USER_ACTIVE = 'USER_ACTIVE'
export const ERROR_USER_WAITING_VERIFICATION = 'USER_WAITING_VERIFICATION'
export const ERROR_USER_EMAIL_EXPIRED = 'USER_EMAIL_EXPIRED'
export const ERROR_NO_ACCESS = 'NO_ACCESS'
export const ERROR_SERVER = 'SERVER_ERROR'
export const ERROR_UNKNOWN_STATE = 'USER_UNKNOWN_STATE'
